// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Tickets_UpdateTicketInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for GET /tickets/updateTicket
 *
 * Updates an existing ticket. All fields are required (full replace, not patch).
 */
import { registerContract } from './validate'

export interface Tickets_UpdateTicketInput {
ID: number
Titulo: string
Prioridade: number
Descricao: string
Usuario: string
CategoriaID: number
}

registerContract('Tickets_UpdateTicketInput', {
  ID:          { type: 'number',  required: true },
  Titulo:      { type: 'string',  required: true },
  Prioridade:  { type: 'number',  required: true },
  Descricao:   { type: 'string',  required: true },
  Usuario:     { type: 'string',  required: true },
  CategoriaID: { type: 'number',  required: true },
})
